// extracted by mini-css-extract-plugin
export default {"cls1":"TxlWTvajtkgNJ6J21wCD","cls2":"RkZzs89lQmi_cG7fFnvf TxlWTvajtkgNJ6J21wCD"};